import React from 'react';
import { Calendar, Phone, Mail } from 'lucide-react';
import ScrollReveal from './ScrollReveal';

const CTASection = ({ onBookAppointment }) => {
  return (
    <section className="py-20 bg-gradient-to-br from-blue-600 to-purple-600 text-white" data-testid="cta-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-5xl font-bold mb-4">
            Ready to Take the First Step?
          </h2>
          <p className="text-xl md:text-2xl opacity-90 max-w-3xl mx-auto">
            Your journey to mental wellness starts with a single decision. We're here to support you.
          </p>
        </div>

        {/* Contact Options */}
        <div className="grid md:grid-cols-3 gap-8 mb-12">
          <ScrollReveal direction="up" delay={0}>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 text-center hover:bg-white/20 transition-colors">
              <Calendar className="w-12 h-12 mx-auto mb-4" />
              <h3 className="text-xl font-bold mb-2">Book Online</h3>
              <p className="mb-4 opacity-90">Schedule your appointment 24/7</p>
              <button
                onClick={onBookAppointment}
                className="bg-white text-blue-600 px-6 py-2 rounded-lg hover:bg-gray-100 transition-colors font-semibold"
                data-testid="cta-book-online-btn"
              >
                Book Now
              </button>
            </div>
          </ScrollReveal>

          <ScrollReveal direction="up" delay={0.15}>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 text-center hover:bg-white/20 transition-colors">
              <Phone className="w-12 h-12 mx-auto mb-4" />
              <h3 className="text-xl font-bold mb-2">Call Us</h3>
              <p className="mb-4 opacity-90">Speak with our team directly</p>
              <a
                href="tel:+18777725150"
                className="inline-block bg-white text-blue-600 px-6 py-2 rounded-lg hover:bg-gray-100 transition-colors font-semibold"
              >
                (877) 772-5150
              </a>
            </div>
          </ScrollReveal>

          <ScrollReveal direction="up" delay={0.3}>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 text-center hover:bg-white/20 transition-colors">
              <Mail className="w-12 h-12 mx-auto mb-4" />
              <h3 className="text-xl font-bold mb-2">Email Us</h3>
              <p className="mb-4 opacity-90">Send us a message anytime</p>
              <a
                href="mailto:info@sdorawellbeing.org"
                className="inline-block bg-white text-blue-600 px-6 py-2 rounded-lg hover:bg-gray-100 transition-colors font-semibold"
              >
                Send Email
              </a>
            </div>
          </ScrollReveal>
        </div>

        {/* Office Hours */}
        <div className="text-center">
          <p className="text-lg opacity-90 mb-2">Office Hours</p>
          <p className="text-xl font-semibold">Monday - Friday: 8:00 AM - 7:00 PM</p>
          <p className="text-xl font-semibold">Saturday: 9:00 AM - 3:00 PM</p>
          <p className="mt-4 opacity-90">Crisis support available 24/7 at 988</p>
        </div>
      </div>
    </section>
  );
};

export default CTASection;